import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Typography
} from '@mui/material';

/**
 * Componente de diálogo para registrar nuevo egreso
 * @param {boolean} open - Si el diálogo está abierto
 * @param {Function} onClose - Función para cerrar el diálogo
 * @param {Array} trabajadoresPendientes - Lista de trabajadores
 * @param {Object} egresoForm - Formulario de egreso
 * @param {Function} setEgresoForm - Setter del formulario
 * @param {Function} onRegistrar - Callback al registrar egreso
 * @param {boolean} loading - Estado de carga
 */
const DialogNuevoEgreso = ({
  open,
  onClose,
  trabajadoresPendientes,
  egresoForm,
  setEgresoForm,
  onRegistrar,
  loading,
  simboloMoneda = 'S/'
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          💸 Registrar Nuevo Egreso
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          {/* Selector de trabajador */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Trabajador</InputLabel>
              <Select
                value={egresoForm.id_trabajador}
                onChange={(e) =>
                  setEgresoForm({ ...egresoForm, id_trabajador: e.target.value })
                }
                label="Trabajador"
              >
                {trabajadoresPendientes.map((trabajador) => (
                  <MenuItem key={trabajador.id_trabajador} value={trabajador.id_trabajador}>
                    {trabajador.nombre_trabajador} {trabajador.apellido_trabajador}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Tipo de egreso y monto */}
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Tipo de Egreso</InputLabel>
              <Select
                value={egresoForm.tipo_egreso}
                onChange={(e) =>
                  setEgresoForm({ ...egresoForm, tipo_egreso: e.target.value })
                }
                label="Tipo de Egreso"
              >
                <MenuItem value="ADELANTO">Adelanto</MenuItem>
                <MenuItem value="DESCUENTO">Descuento</MenuItem>
                <MenuItem value="MULTA">Multa</MenuItem>
                <MenuItem value="PRESTAMO">Préstamo</MenuItem>
                <MenuItem value="OTROS">Otros</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Monto"
              type="number"
              value={egresoForm.monto}
              onChange={(e) => setEgresoForm({ ...egresoForm, monto: e.target.value })}
              InputProps={{
                startAdornment: <Typography sx={{ mr: 1 }}>{simboloMoneda}</Typography>
              }}
            />
          </Grid>

          {/* Concepto */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Concepto"
              value={egresoForm.concepto}
              onChange={(e) => setEgresoForm({ ...egresoForm, concepto: e.target.value })}
              placeholder="Ej: Adelanto por gastos médicos"
              required
            />
          </Grid>

          {/* Observaciones */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Observaciones"
              multiline
              rows={3}
              value={egresoForm.observaciones}
              onChange={(e) =>
                setEgresoForm({ ...egresoForm, observaciones: e.target.value })
              }
              placeholder="Detalles adicionales..."
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onRegistrar}
          disabled={
            loading ||
            !egresoForm.id_trabajador ||
            !egresoForm.concepto ||
            !egresoForm.monto
          }
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)'
          }}
        >
          {loading ? 'Registrando...' : 'Registrar Egreso'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogNuevoEgreso;
